import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PricingRouteProps } from './types';

const UPGRADE_PATH = '/pricing/upgrade/';

const PricingRoutes: React.FC<PricingRouteProps> = ({ redirectPath, path, ...rest }) => {
  // Since we will eventually get rid of the upgrade path
  if (path?.includes(UPGRADE_PATH)) {
    return <Redirect to={{ pathname: redirectPath }} />;
  }
  return <Route {...rest} />;
};

export default PricingRoutes;
